import { interfaces } from "inversify";

export default function servicePathFactory(context: interfaces.Context) {
  const parent = context.currentRequest.parentRequest;
  if (parent && parent.target.matchesNamedTag("UserProfileService")) {
    return process.env.VUE_APP_RAS_REST_CLIENT_APPHQ_URL;
  } else {
    return process.env.VUE_APP_RAS_REST_CLIENT_RVK_URL;
  }
}
